import { useEffect, useState } from "react";
import { toast } from "sonner";
import { errMsg } from "@/lib/api";
import useAdminApi from "@/hooks/useAdminApi";

const RoomRow = ({ room, onSave }) => {
  const [f, setF] = useState({ price: room.price ?? "", inventory: room.inventory, capacity: room.capacity, active: room.active });
  const save = () => {
    const body = { inventory: +f.inventory, capacity: +f.capacity, active: f.active };
    if (f.price === "" || f.price === null) body.clear_price = true;
    else body.price = +f.price;
    onSave(room, body);
  };
  const id = `${room.property_slug}-${room.slug}`;
  return (
    <tr className="border-b border-[#E2DCD0]" data-testid={`admin-room-row-${id}`}>
      <td className="py-3 pr-3 text-sm min-w-[180px]">{room.name}</td>
      <td className="py-3 pr-3"><input type="number" min={0} placeholder="On request" className="field !h-9 w-32" value={f.price} onChange={(e) => setF({ ...f, price: e.target.value })} data-testid={`admin-room-price-${id}`} /></td>
      <td className="py-3 pr-3"><input type="number" min={0} className="field !h-9 w-20" value={f.inventory} onChange={(e) => setF({ ...f, inventory: e.target.value })} data-testid={`admin-room-inventory-${id}`} /></td>
      <td className="py-3 pr-3"><input type="number" min={1} className="field !h-9 w-20" value={f.capacity} onChange={(e) => setF({ ...f, capacity: e.target.value })} data-testid={`admin-room-capacity-${id}`} /></td>
      <td className="py-3 pr-3"><input type="checkbox" className="accent-[#1E3B2E] h-4 w-4" checked={f.active} onChange={(e) => setF({ ...f, active: e.target.checked })} data-testid={`admin-room-active-${id}`} /></td>
      <td className="py-3"><button onClick={save} className="btn-primary !h-9 !px-4 !text-[10px]" data-testid={`admin-room-save-${id}`}>Save</button></td>
    </tr>
  );
};

export default function RoomsTab() {
  const call = useAdminApi();
  const [rooms, setRooms] = useState([]);
  const [props, setProps] = useState([]);
  const [sel, setSel] = useState("udaipur");
  useEffect(() => {
    call("get", "/admin/rooms").then(setRooms).catch((e) => toast.error(errMsg(e)));
    call("get", "/properties").then((p) => setProps(p.filter((x) => !x.coming_soon)));
  }, [call]);

  const onSave = async (room, body) => {
    try {
      await call("patch", `/admin/rooms/${room.property_slug}/${room.slug}`, body);
      toast.success(`${room.name} updated`);
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  const list = rooms.filter((r) => r.property_slug === sel);

  return (
    <div className="bg-white border border-[#E2DCD0] p-5 sm:p-6">
      <div className="flex flex-col sm:flex-row sm:items-center gap-3 justify-between mb-4">
        <select className="field sm:w-80" value={sel} onChange={(e) => setSel(e.target.value)} data-testid="admin-rooms-property-select">
          {props.map((p) => <option key={p.slug} value={p.slug}>{p.name}</option>)}
        </select>
        <p className="text-xs text-[#6b6b6b]">Prices are per night in INR, inclusive of GST &amp; breakfast. Leave price empty for "Price on request".</p>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full text-left">
          <thead><tr className="eyebrow text-[#6b6b6b] !text-[10px] border-b border-[#E2DCD0]"><th className="py-2">Room</th><th>Price / night</th><th>Rooms</th><th>Max guests</th><th>Active</th><th /></tr></thead>
          <tbody>{list.map((r) => <RoomRow key={`${r.property_slug}-${r.slug}`} room={r} onSave={onSave} />)}</tbody>
        </table>
      </div>
    </div>
  );
}
